import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocaleService } from '@core/localization/locale.service';
import { CurrencyFormatPipe } from '@shared/pipes';
import {
    DateFormatService,
    FileReaderService,
    HtmlLoaderService,
    ImageResizeService,
    ImageUtilsService,
    MatDialogService,
    MonthService,
    NoAuthGuard,
    TariffsApiService,
} from './services';


@NgModule({
    providers: [
        FileReaderService,
        ImageResizeService,
        DateFormatService,
        ImageUtilsService,
        HtmlLoaderService,
        MatDialogService,
        NoAuthGuard,
        MonthService,
        TariffsApiService,
        LocaleService,
        CurrencyFormatPipe,
        DecimalPipe,
    ],
})
export class SharedModule {
}
